export default "__VITE_ASSET__CFlOB4Nw__"